import { css } from "@emotion/css"
import { useCallback, useId } from "react"
import { Tooltip } from "react-tooltip"
import "react-tooltip/dist/react-tooltip.css"

import ImageButton from "@p-ban/common/src/components/html/ImageButton"

import ScrollTopButton from "../../../../../components/ScrollTopButton/ScrollTopButton"
import COLOR_CODE from "../../constant/color"
import MODAL_ID from "../../constant/modalId"
import Z_INDEX from "../../constant/zIndex"
import { useModal } from "../modal/useModal"

import clearImage from "./clear.png"
import shareImage from "./share.png"

type Props = {
  resetForm: () => void
}

const Menu = ({ resetForm }: Props) => {
  const linkId = useId()
  const clearId = useId()
  const reset = useCallback(() => {
    if (window.confirm("入力内容をクリアします。よろしいですか？")) {
      resetForm()
    }
  }, [resetForm])

  const { open } = useModal(MODAL_ID.SHARE_LINK)

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <ImageButton
          className={styles.button}
          hoverClassName={styles.buttonHover}
          onClick={open}
          id={linkId}
          src={shareImage}
          alt="リンクを共有"
          width={42}
          height={39}
        />
        <ImageButton
          className={styles.button}
          hoverClassName={styles.buttonHover}
          onClick={reset}
          id={clearId}
          src={clearImage}
          alt="クリア"
          width={42}
          height={39}
        />
      </div>
      <Tooltip anchorId={linkId} place="left" content="リンクを共有" />
      <Tooltip anchorId={clearId} place="left" content="クリア" />
      <ScrollTopButton />
    </div>
  )
}

export default Menu

const styles = {
  container: css`
    position: fixed;
    right: 0;
    bottom: 100px;
    z-index: ${Z_INDEX.MENU};
  `,
  inner: css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-bottom: 15px;
  `,
  button: css`
    display: block;
    width: 42px;
    height: 39px;
    background-color: ${COLOR_CODE.WHITE};
    border: 1px solid ${COLOR_CODE.FOOTER_MENU_BUTTON_GRAY};
    border-right: none;

    &:first-child {
      border-radius: 5px 0px 0px 0px;
    }
    &:last-child {
      border-top: none;
      border-radius: 0px 0px 0px 5px;
    }
  `,
  buttonHover: css`
    opacity: 0.7;
  `,
}
